import styled from "styled-components";

export const LinkProcesso = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: #1f6feb;
  text-decoration: underline;
  cursor: pointer;
`;
